import * as types from './constants'
import apiService from '../../apiService/apiService'

export const addToCart = (product) => {
    return (dispatch) => {
        dispatch({
            type: types.ADD_TO_CART,
            payload: product,
        })
    }
}

export const updateCartMeterage = (productId, newMeterage) => {
    return (dispatch, getState) => {
        const cartItems = getState().payment.cart

        dispatch({
            type: types.SET_CART,
            payload: cartItems.map((q) => {
                if (q.id === productId) q.meterage = newMeterage
                return q
            }),
        })
    }
}

export const removeFromCart = (productId) => {
    return (dispatch, getState) => {
        const cartItems = getState().payment.cart

        dispatch({
            type: types.SET_CART,
            payload: cartItems.filter((q) => q.id !== productId),
        })
    }
}

export const resetCart = () => {
    return (dispatch) => {
        dispatch({
            type: types.RESET_CART,
        })
    }
}

export const getAddresses = (profileId) => {
    return (dispatch) => {
        apiService.profile
            .getAddresses(profileId)
            .then((response) => {
                if (response.status == 200) {
                    const addresses = response.data
                    dispatch({
                        type: types.GET_ADDRESSES_START,
                        payload: addresses,
                    })
                } else {
                    dispatch({
                        type: types.GET_ADDRESSES_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.GET_ADDRESSES_FAIL,
                    error: errorMessage,
                })
            })
    }
}

export const buyOrder = (history) => {
    return (dispatch, getState) => {
        const cartItems = getState().payment.cart
        dispatch({
            type: types.SUBMIT_ORDER_START,
        })

        apiService.payment
            .submitOrder(cartItems)
            .then((response) => {
                if (response.status == 200) {
                    dispatch({
                        type: types.SUBMIT_ORDER_SUCCESS,
                        payload: response.data,
                    })
                    history.push({
                        pathname: '/payment/result',
                        search: `?id=${response.data}`,
                    })
                } else {
                    dispatch({
                        type: types.SUBMIT_ORDER_FAIL,
                        error:
                            response.data.message ||
                            response.data.errors[0].description,
                    })
                    history.push({
                        pathname: '/payment/result',
                    })
                }
            })
            .catch((error) => {
                let errorMessage = error
                if (error?.response?.data) errorMessage = error.response.data
                dispatch({
                    type: types.SUBMIT_ORDER_FAIL,
                    error: errorMessage,
                })
                history.push({
                    pathname: '/payment/result',
                })
            })
    }
}
